import AppLayout from '../../components/AppLayout';
import LoginForm from '../../components/LoginForm';
import LoginRegisterBody from '../../components/LoginRegisterBody';

export default function LoginPage() {
  return (
    <AppLayout>
      <LoginRegisterBody>
        <LoginForm />
      </LoginRegisterBody>
    </AppLayout>
  );
}
